import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareChecklistBell: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="square-checklist-bell, checklist box, check, list, search"><path d="M7.54296 9.49775L8.66796 10.2478L10.5396 7.75224M13.8079 9H16.3079M7.54296 15.4989L8.66796 16.2489L10.5396 13.7534M20.25 10.75V3.75H3.75V20.25H11.75M16.8912 20.5777C17.0998 20.9772 17.518 21.25 18 21.25C18.482 21.25 18.9002 20.9772 19.1088 20.5777M21.25 20.25V17C21.25 15.2051 19.7949 13.75 18 13.75C16.2051 13.75 14.75 15.2051 14.75 17V20.25H21.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSquareChecklistBell;
